<template>
  <q-infinite-scroll :initial-index="-1" @load="load" >
    <q-timeline color="primary">
      <q-timeline-entry v-for="log in logs" :icon="taskActionsIcons[log.action]"
                        :title="`${log.user.username} ${taskActions[log.action]}`"
                        :subtitle="dayJs.utc(log.actionTime).local().format('L LT')">
      </q-timeline-entry>
    </q-timeline>
    <template v-slot:loading>
      <div class="row justify-center q-my-md">
        <q-spinner-dots color="primary" size="40px"/>
      </div>
    </template>
  </q-infinite-scroll>
</template>

<script setup lang="ts">
import {useDayJs} from "../composables/dayjs";
import {useRoute} from "vue-router";
import {computed, ref} from "vue";
import {useTaskLogs} from "../composables/task";
import {TaskLog} from "../models/task";
import {taskActionsIcons, taskActions} from "../util/actions";

const dayJs = useDayJs()
const route = useRoute()

const projectId = computed(() => Number(route.params.projectId))
const taskId = computed(() => Number(route.params.taskId))

const logs = ref<TaskLog[]>([])

async function loadLogs(index: number) {
  const {data: pageLogs} = await useTaskLogs(projectId, taskId, index)
  logs.value = logs.value.concat(pageLogs.value?.content ?? [])
  return pageLogs.value?.last
}

function load(index: number, done: (stop?: boolean) => void) {
  if (index === 0) {
    logs.value = []
  }
  loadLogs(index).then(v => done(v))
}

</script>

<style scoped>

</style>